import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfContenidoPublicitario } from '@/modules/Configuracion/interfaces/tablas/IConfContenidoPublicitario'

export class ContenidoPublicitarioService extends BaseService<IConfContenidoPublicitario> {
  constructor () {
    super({ baseUrl: 'pantalla/contenido/' })
  }
}
